
<!--企业简介-首页左侧-->
<template>
  <div>
    <div class="mybox">
      <div class="title">企业简介</div>
      <div class="box aboutus">
        <div style="text-indent: 1.1rem;" class="text">{{aboutus.content}}</div>
        <div class="aboutlist">
          <div>
            <p>智慧工厂进度</p>
            <div class="pro"><span :style="'width:'+aboutus.smartProgress+'%'"></span></div>
          </div>
          <div>
            <p>工业互联网进度</p>
            <div class="pro"><span :style="'width:'+aboutus.industryProgress+'%'"></span></div>
          </div>
          <div>
            <p>智能化信息化融合进度</p>
            <div class="pro"><span :style="'width:'+aboutus.informatProgress+'%'"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mybox">
      <div class="title">行业地位</div>
      <div class="box hangye">
        <div class="left"><img :src="hangye.describeUrl"></div>
        <div class="right">
          <!-- <div class="title">{{hangye.title}}</div> -->
          <div class="text">{{hangye.content}}</div>
        </div>
      </div>
    </div>
    <div class="mybox">
      <div class="title">新闻资讯</div>
      <div class="box">
        <NewList></NewList>
      </div>
    </div>
    <div class="mybox">
      <div class="title">企业文化</div>
      <div class="box">
        <NewList1></NewList1>
      </div>
    </div>
  </div>



</template>

<script>
import api from '@/apis/CompanyProfile'
import NewList from './NewList' //新闻资讯
import NewList1 from './NewList1' //企业文化
export default {
  components: {
    NewList,
    NewList1,
  },
  data() {
    return {
      aboutus: {
        content: '暂无',
        industryProgress: 49,
        informatProgress: 79,
        smartProgress: 69,
      },

      hangye: {
        describeUrl: require('@/assets/images/pic.png'),
        title: '创研实力 自主创新 同步全球',
        content:
          '中国联塑集团控股有限公司（简称：中国联塑，股份代号：2128中国联塑集团控股有限公司（简称：中国联塑，股份代号：2128中国联塑集团控股有限公司（简称：中国联塑，股份代号：2128中国联塑集团控股有限公司（简称：中国联塑，股份代号：2128',
      },

      zizhiData: [
        {
          id: 0,
          list: [
            { url: require('@/assets/images/pic2.png') },
            { url: require('@/assets/images/pic3.png') },
          ],
        },
        {
          id: 1,
          list: [
            { url: require('@/assets/images/pic3.png') },
            { url: require('@/assets/images/pic3.png') },
          ],
        },
      ],
      rongyuData: [
        {
          id: 0,
          list: [
            { id: 0, picture: require('@/assets/images/pic2.png') },
            { id: 1, picture: require('@/assets/images/pic3.png') },
            { id: 2, picture: require('@/assets/images/pic3.png') },
          ],
        },
        {
          id: 1,
          list: [
            { id: 3, picture: require('@/assets/images/pic3.png') },
            { id: 4, picture: require('@/assets/images/pic3.png') },
            { id: 5, picture: require('@/assets/images/pic2.png') },
          ],
        },
      ],
      lichengid: 0,
      licheng: [
        { id: 0, content:'请添加数据',eTime: '2017-07-01 00:00:00', backImg: require('@/assets/images/nodata.png') },
        { id: 1, content:'请添加数据',eTime: '2018-08-01 00:00:00', backImg: require('@/assets/images/nodata.png') },
        { id: 2, content:'请添加数据',eTime: '2019-09-01 00:00:00', backImg: require('@/assets/images/nodata.png') },
        { id: 3, content:'请添加数据',eTime: '2020-10-01 00:00:00', backImg: require('@/assets/images/nodata.png') },
      ],
      RYdialog: false,
      RYinfo: {
        name: 'name',
        picture: require('@/assets/images/pic.png'),
        remark: '内容',
      },
      //企业形像
      qyxx: {
        imgUrl: require('@/assets/images/pic.png'),
      },
      timer:null,
    }
  },
  methods: {
    lichengClick(index) {
      this.lichengid = index
    },
    RYclick(item) {
      // console.log(item)
      this.RYinfo = item
      this.RYdialog = true
    },




    scroll(type) {
  
      let liWidth = document.querySelector('.lcbox .lilist').offsetWidth
      if(type){
        document.querySelector('.lcbox .lilist').style ='transition: all 0.2s;margin-left: -' -  liWidth +'px;'
        setTimeout(() => {
          this.licheng.unshift(this.licheng.pop())
          document.querySelector('.lcbox .lilist').style = 'width: '-liWidth+'px;'
        }, 200)
      }else{
       
        document.querySelector('.lcbox .lilist').style ='transition: all 0.2s;margin-left: -' +  liWidth +'px;'
        setTimeout(() => {
          this.licheng.push(this.licheng.shift())
          document.querySelector('.lcbox .lilist').style = 'width: '+liWidth+'px;'
        }, 200)
      }

    },
    lcboxMouseover(){
      //进入
      console.log('lcboxMouseover');
      clearInterval(this.timer)
    },
    lcboxMouseout(){
      //离开
      console.log('lcboxMouseout');
      if (this.licheng.length>=4) {
        this.timer = setInterval(this.scroll, 3000)
      }
    },


  },
  beforeDestroy(){
    clearInterval(this.timer)
  },
  mounted() {
    //企业形像
    api.qyxx().then((res) => {
      if (res.code === 10000) {
        this.qyxx = res.data
      } else {
        this.$message.error(res.message)
      }
    })
    //企业简介
    api.qyjj().then((res) => {
      if (res.code === 10000) {
        this.aboutus = res.data
      } else {
        this.$message.error(res.message)
      }
    })
    //行业地位
    api.hangye().then((res) => {
      if (res.code === 10000) {
        this.hangye = res.data
      } else {
        this.$message.error(res.message)
      }
    })
     
  },
}
</script>

<style lang="less" scoped>
.aboutus {
    display: flex;
    flex-direction: column;
    padding: 0.71rem;
    font-size: 0.65rem;
    .text {
      flex: 1;
      overflow: hidden;
      line-height: 1.15rem;
    }
    .aboutlist {
      height: 2.9rem;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      & > div {
        flex: 1;
        color: #05f8fc;
        .pro {
          margin-top: 10px;
          height: 0.5rem;
          width: 100%;
          border-radius: 50px;
          background: #1a3eca;
          span {
            display: block;
            height: 100%;
            border-radius: 50px;
          }
        }
      }
      & > div:nth-child(1) {
        .pro {
          span {
            background: #24ffb1;
            box-shadow: 0 0 5px #24ffb1;
          }
        }
      }
      & > div:nth-child(2) {
        margin: 0 1.5rem;
        .pro {
          span {
            background: #00ccff;
            box-shadow: 0 0 5px #00ccff;
          }
        }
      }
      & > div:nth-child(3) {
        margin: 0 1.5rem;
        .pro {
          span {
            background: #ae74f3;
            box-shadow: 0 0 5px #ae74f3;
          }
        }
      }
    }
  }
.hangye {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0.71rem;
    .left {
      width: 10.5rem;
      height: 100%;
      overflow: hidden;
      margin-right: 0.8rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 0.8rem;
        color: #05f8fc;
        height: 1.5rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .text {
        flex: 1;
        overflow: hidden;
        font-size: 0.65rem;
        line-height: 1.1rem;

        &:first-line {
          color: #05f8fc;
          overflow: hidden;
          font-size: 0.8rem;
        }
      }
    }
  }


.cp_home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      // height: 25%;
      overflow: hidden;
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }

  .aboutus {
    display: flex;
    flex-direction: column;
    padding: 0.71rem;
    font-size: 0.65rem;
    .text {
      flex: 1;
      overflow: hidden;
      line-height: 1.15rem;
    }
    .aboutlist {
      height: 2.9rem;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      & > div {
        flex: 1;
        color: #05f8fc;
        .pro {
          margin-top: 10px;
          height: 0.5rem;
          width: 100%;
          border-radius: 50px;
          background: #0c2667;
          span {
            display: block;
            height: 100%;
            border-radius: 50px;
          }
        }
      }
      & > div:nth-child(1) {
        .pro {
          span {
            background: #24ffb1;
            box-shadow: 0 0 5px #24ffb1;
          }
        }
      }
      & > div:nth-child(2) {
        margin: 1rem;
        .pro {
          span {
            background: #00ccff;
            box-shadow: 0 0 5px #00ccff;
          }
        }
      }
      & > div:nth-child(3) {
        margin: 0 1.5rem;
        .pro {
          span {
            background: #ae74f3;
            box-shadow: 0 0 5px #ae74f3;
          }
        }
      }
    }
  }
  .hangye {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0.71rem;
    .left {
      width: 10.5rem;
      height: 100%;
      overflow: hidden;
      margin-right: 0.8rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 0.8rem;
        color: #05f8fc;
        height: 1.5rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .text {
        flex: 1;
        overflow: hidden;
        font-size: 0.65rem;
        line-height: 1rem;

        &:first-line {
          color: #05f8fc;
          overflow: hidden;
          font-size: 0.8rem;
        }
      }
    }
  }
  .cp_carousel {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0.71rem 0.3rem;
    .zhizhilist {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      .img {
        width: 50%;
        margin: 0 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .rongyulist {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      .img {
        width: 33.33%;
        margin: 0 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }




  .licheng {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0.71rem 2.6rem 0.71rem 2.5rem;
    overflow: hidden;
    .preleft,
    .preright {
      position: absolute;
      top: 36%;
      width: 1.9rem;
      left: 10px;
      img {
        width: 100%;
      }
    }
    .preright {
      left: auto;
      right: 10px;
    }
    .lcbox {
       position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;

      &::before {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 8px;
        background: #5586ff;
        border-radius: 20px;
        top: 92%;
      }
      .lilist:hover{
        position: relative;
        .image{
          color: #064f50;
        }
        img:hover{
          position: relative;
          box-shadow: 5px 5px 30px #1b1a1b ;
          z-index: 4;
          transform: scale(1.1);
          // width: 110% !important;
          // height: 110% !important;
          // left: -5% !important;
          // top:-2%;

        }
      }

      .lilist {
        
        // width: 250%;
        min-width: 50px;
        width: 25%;
        height: 100%;
        // flex: 1;
        .image{
          position: relative;
          height: 80%;
          padding: 0 0.3rem;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
          }
          span{
            z-index: 5;
            position: absolute;
            left: 0.5rem;
            bottom: 0.1rem;
          }
        }



          
        .progress {
          position: relative;
          z-index: 5;
          height: 20%;

          // flex: 1;
          text-align: center;
          z-index: 9;
          span {
            margin: 6px auto 0;
            cursor: pointer;
            width: 0.8rem;
            height: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 1rem;
            background: #5586ff;
            border: #05f8fc solid 2px;
          }
        }

        .progress.active {
          color: #24ffb1;
          font-weight: bold;
          span {
            width: 1rem;
            height: 1rem;
            border: #24ffb1 solid 3px;
            margin-top: 3px;
          }
          span::after {
            content: ' ';
            position: relative;
            top: -0.8px;
            left: 0.5px;
            width: 0.4rem;
            height: 0.4rem;
            background: #24ffb1;
            border-radius: 50%;
          }
        }

      }
    }

  }

  .rongyudialog {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
      width: 19rem;
      height: 25rem;
      margin-right: 1rem;
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .title {
        font-weight: bold;
        margin-bottom: 15px;
        font-size: 0.9rem;
      }
      .text {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        line-height: 1rem;
      }
    }
  }
}
</style>
